const util = {
    /**
     *
     * @param {any} map 
     * @param {any} opts 
     * @param {any} opts.scaleMaxWidth
     * @returns {Object}
     */
    getScale(map, opts) {
        //todo 坐标系处理？
        let bounds = map.getExtent(),
            centerLat = bounds.center().y,
            halfWorldMeters = 6378137 * Math.PI * Math.cos(centerLat * Math.PI / 180),
            dist = halfWorldMeters * (bounds.maxx - bounds.minx) / 180,
            size = map.getViewSize(),
            maxWidth = opts.scaleMaxWidth,
            maxMeters = 0;
        if (size[0] > 0) {
            maxMeters = dist * (maxWidth / size[0]);
        }
        let meters = this.getRoundNum(maxMeters);
        return {
            "width": this.getScaleWidth(opts.scaleMaxWidth, meters / maxMeters),
            "scale": meters,
            "scaleText": meters < 1000 ? meters + ' m' : (meters / 1000) + ' km'
        }
    },
    /**
     * @param {any} num 
     */
    getRoundNum(num) {
        let pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
            d = num / pow10;
        d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
        return pow10 * d;
    },
    getScaleWidth(scaleMaxWidth, ratio) {
        return Math.round(scaleMaxWidth * ratio) - 10;
    },
};
module.exports = util;